import { flow, split, get, toUpper } from 'lodash/fp';
import { LOCALE } from 'helpers/i18n';
import localeToCountry from './localeToCountry';

const SHORT_LOCALE_LENGTH = 2;
const LONG_LOCALE_LENGTH = 5;
const LANGUAGE_LENGTH = 2;

const getCountryByLocale = (locale) => {
  if (localeToCountry[locale]) {
    return localeToCountry[locale];
  } else if (locale.length === SHORT_LOCALE_LENGTH) {
    return toUpper(locale);
  } else if (locale.length === LONG_LOCALE_LENGTH) {
    return flow(split(/_|-/), get([1]), toUpper)(locale);
  }

  throw new Error(`Invalid locale format! Locale:${locale}`);
};

const getLanguageByLocale = (locale) => {
  return locale.slice(0, LANGUAGE_LENGTH);
};

export const COUNTRY = getCountryByLocale(LOCALE);
export const LANGUAGE = getLanguageByLocale(LOCALE);

export default getCountryByLocale;
